import template from './button-promise.internals.html';
export default angular
  .module('doxy.common.components.buttonPromise', [])
  .directive(
    'buttonPromise',
    function ($sce, $interval, $timeout, $q, notificationFactory) {
      function increment(num) {
        return 6.0 * Math.exp(-5.0 * (num / 100));
      }

      return {
        template,
        transclude: true,
        restrict: 'A',
        scope: {
          buttonPromise: '<',
        },
        link: function (scope, element) {
          scope.content = $sce.trustAsHtml(element.html());

          let progressPromise;
          const progressBar = element[0].querySelector('.button__progress');
          scope.progress = 0;

          function startProgress() {
            element.attr({ disabled: true });
            progressPromise = $interval(function () {
              scope.progress = scope.progress + increment(scope.progress);
            }, 250);
          }

          function finishState(isSuccess) {
            const finishClass = 'button--' + (isSuccess ? 'success' : 'error');
            element.addClass(finishClass);

            $timeout(function () {
              element.removeClass(finishClass);
              element.removeClass('button--loading');
              element.attr({ disabled: false });
            }, 2000);
          }

          function resetBar() {
            progressBar.classList.add('notransition');
            scope.progress = 0;
            $timeout(function () {
              progressBar.classList.remove('notransition');
            }, 250);
          }

          function progressEnd(isSuccess) {
            element.attr({ disabled: false });
            $interval.cancel(progressPromise);
            scope.progress = 100;
            $timeout(function () {
              resetBar();
              finishState(isSuccess);
            }, 500);
          }

          scope.$watch('buttonPromise', function (newValue) {
            if (!newValue) return;
            element.addClass('button--loading');
            startProgress();
            $q.when(newValue)
              .then(() => progressEnd(true))
              .catch((err) => {
                notificationFactory.showError(err);
                return progressEnd(false);
              });
          });
        },
      };
    }
  ).name;
